import * as yup from 'yup';

export const UserEditValidation = yup.object().shape({
	accountEmail: yup.string().email('Please enter a valid email'),
	useremail: yup.string().nullable().email('Please enter a valid email'),
});
